import Dialog from '@ui/components/Dialog/Dialog';
import { cn } from '@ngg/storefront-utils';
import { ReactNode } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  CloseButton?: () => ReactNode;
  title?: ReactNode;
};

export default function MobileDrawer(props: Props) {
  const { title, open, onClose, CloseButton, children } = props;
  return (
    <Dialog
      dialogTransitionProps={{
        enter: 'ease-in duration-200',
        enterFrom: '-translate-x-full',
        enterTo: 'translate-x-0',
        leave: 'ease-in duration-200',
        leaveFrom: 'translate-x-0',
        leaveTo: '-translate-x-full',
      }}
      backdropTransitionProps={{
        enter: 'ease-out duration-300',
        enterFrom: 'opacity-0',
        enterTo: 'opacity-100',
        leave: 'ease-in duration-200',
        leaveFrom: 'opacity-100',
        leaveTo: 'opacity-0',
      }}
      title={title}
      open={open}
      onClose={onClose}
      CloseButton={CloseButton}
      classNames={{
        backdrop: 'bg-black/60',
        panel: cn([
          'py-0 rounded-none scrollbar-none fixed m-0 pb-0 left-0 z-40 flex bottom-0 flex-col h-full overflow-y-auto overflow-x-hidden bg-main max-w-none border-l border-borderColor max-w-xs',
        ]),
        title: 'font-bold text-left leading-4 tracking-0.02em text-base',
        panelHeader:
          'flex w-full items-start justify-between p-4 text-sm font-bold border-b',
        container: 'border border-l-1-borderColor',
      }}>
      {children}
    </Dialog>
  );
}
